/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { IntercomUserJwtDTO } from '../fastAPI.schemas'

/**
 * A messenger JWT proving the caller's identity to Intercom.

Returns ``token: null`` instead of failing when the Intercom secret is
not configured (local development) or the access token carries no email
(mock auth) - the messenger is a support channel, and a missing signature
must never break the app around it.
 * @summary Get Intercom User Jwt
 */
export const getIntercomUserJwt = (signal?: AbortSignal) => {
  return customInstance<IntercomUserJwtDTO>({ url: `/intercom/user-jwt`, method: 'GET', signal })
}

export const getGetIntercomUserJwtQueryKey = () => {
  return [`/intercom/user-jwt`] as const
}

export const getGetIntercomUserJwtQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntercomUserJwt>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getIntercomUserJwt>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetIntercomUserJwtQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntercomUserJwt>>> = ({ signal }) =>
    getIntercomUserJwt(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntercomUserJwt>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetIntercomUserJwtQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntercomUserJwt>>
>
export type GetIntercomUserJwtQueryError = unknown

/**
 * @summary Get Intercom User Jwt
 */

export function useGetIntercomUserJwt<
  TData = Awaited<ReturnType<typeof getIntercomUserJwt>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getIntercomUserJwt>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetIntercomUserJwtQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
